import { useEffect } from 'react';

const LANDBOT_SDK = 'https://cdn.landbot.io/landbot-3/landbot-3.0.0.mjs';

/**
 * Widget de Landbot (livechat). Específico de tenant: solo se carga si
 * `NEXT_PUBLIC_LANDBOT_CONFIG_URL` está definido en el `.env` del tenant
 * (mismo patrón que GTM / CookiePro). Si está vacío, no se inyecta nada.
 *
 * Carga diferida: el SDK solo se inyecta en la primera interacción del
 * usuario (mouseover/touchstart) para no penalizar el tiempo de carga.
 */
export const Landbot = () => {
  const configUrl = process.env.NEXT_PUBLIC_LANDBOT_CONFIG_URL;

  useEffect(() => {
    if (!configUrl) return;

    let initialized = false;
    const init = () => {
      if (initialized) return;
      initialized = true;

      const script = document.createElement('script');
      script.type = 'module';
      script.async = true;
      script.src = LANDBOT_SDK;
      script.addEventListener('load', () => {
        // @ts-expect-error Landbot se expone como global tras cargar el SDK
        new window.Landbot.Livechat({ configUrl });
      });
      document.body.appendChild(script);
    };

    window.addEventListener('mouseover', init, { once: true });
    window.addEventListener('touchstart', init, { once: true });

    return () => {
      window.removeEventListener('mouseover', init);
      window.removeEventListener('touchstart', init);
    };
  }, [configUrl]);

  return null;
};

Landbot.displayName = 'Landbot';
